import { useSelector } from 'react-redux';
import { translate } from '../../lib/lang.helper';
import { DollarIcon, Input } from '../shared';
import { selectLang } from '../../store/ui/ui.selector';
import { IExpenseRequest } from '../../entities/budget.entities';
import ExpensesForm from '../grower-views/ExpensesForm';
import { selectAccount } from '../../store/auth/auth.selector';
import { numToStr } from '../../lib/common.helpers';

interface IForm {
  income?: number | null;
  income_details?: IExpenseRequest[];
  cost?: number | null;
  budget_unit_amount?: number | null;
  budget_unit_price?: number | null;
  expenses?: IExpenseRequest[];
}

interface Props {
  detailedBudgetEnabled: boolean | undefined;
  form: IForm;
  onChange: (form: any) => void;
  showUnits?: boolean;
  incomeType?: 'normal' | 'detailed';
  disabled?: boolean;
}

const OperatorBudgetForm = ({
  detailedBudgetEnabled,
  form,
  onChange,
  showUnits = false,
  incomeType,
  disabled,
}: Props) => {
  const lang = useSelector(selectLang);
  const factoryCosts = useSelector(selectAccount)?.factory_costs;

  const handleChange = (key: keyof IForm, value: string) => {
    const val = value.length > 0 ? Number(value) : null;
    onChange({ ...form, [key]: val });
  };

  return (
    <div className='mt-12'>
      {incomeType === 'normal' ? (
        <div className='mb-17'>
          <Input
            type='number'
            onChange={e => handleChange('income', e.target.value)}
            value={numToStr(form.income)}
            unit={<DollarIcon />}
            label={translate(lang, 'Harvest income')}
            disabled={disabled}
          />
        </div>
      ) : incomeType === 'detailed' ? (
        <div className='section-modal'>
          <ExpensesForm
            className='section'
            title={translate(lang, 'Income details')}
            data={form.income_details ?? []}
            setData={data => onChange({ ...form, income_details: data })}
            options={factoryCosts?.map(x => ({
              name: x.quality,
              price: x.unit_ton_price,
            }))}
          />
        </div>
      ) : (
        <></>
      )}
      {detailedBudgetEnabled ? (
        <div className='section-modal'>
          <ExpensesForm
            className='section'
            title={translate(lang, 'Expenses details')}
            data={form.expenses ?? []}
            setData={data => onChange({ ...form, expenses: data })}
          />
        </div>
      ) : (
        <div className='mb-17'>
          <Input
            label={translate(lang, 'Cost')}
            type='number'
            value={numToStr(form.cost)}
            dataType='cost'
            unit='$'
            onChange={e => handleChange('cost', e.target.value)}
            disabled={disabled}
          />
        </div>
      )}
      {showUnits && (
        <>
          <div className='mb-17'>
            <Input
              label={translate(lang, 'Budgeted kg/m')}
              type='number'
              value={numToStr(form.budget_unit_amount)}
              unit='kg/m'
              onChange={e => handleChange('budget_unit_amount', e.target.value)}
              disabled={disabled}
            />
          </div>
          <div className='mb-17'>
            <Input
              label={translate(lang, 'Budgeted $/m')}
              type='number'
              value={numToStr(form.budget_unit_price)}
              unit='$/m'
              onChange={e => handleChange('budget_unit_price', e.target.value)}
              disabled={disabled}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default OperatorBudgetForm;
